
import axios from 'axios';

// In dev the CRA dev server proxies "/api" to the backend on :5000.
// In production we ship the React build to one origin (the main domain)
// and the Node backend to another (the API subdomain), so axios needs an
// absolute base URL. Set REACT_APP_API_URL in client/.env.production at
// build time, e.g. https://api.alghadalmoshreq.com/api
const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user && user.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

// ---------------- USERS ----------------
export const addUser = (userData) => api.post('/users/add', userData);
export const backupDatabase = async () => {
    
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user ? user.token : null; 

    const response = await fetch(`${API_BASE}/users/backup`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    return response.json().then(error => {
      throw new Error(error.message || 'فشل في استرداد النسخة الاحتياطية.');
    });
  }
  return response;
};
export const restoreDatabase = async (formData) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const token = user ? user.token : null;

  const res = await fetch(`${API_BASE}/backup/restore`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData,
  });
  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.message || 'فشل في عملية الاستعادة');
  }
  return await res.json();
};

// ---------------- AUTH ----------------
export const login = (credentials) => api.post('/auth/login', credentials);

// ---------------- STUDENTS ----------------
export const getStudents = (page = 1, limit = 10) =>api.get(`/students/getStudents?page=${page}&limit=${limit}`);
export const addStudent = (studentData) => api.post('/students/addStudent', studentData);
export const updateStudent = (id, studentData) => api.put(`/students/updateStudent/${id}`, studentData);
export const deleteStudent = (id) => api.delete(`/students/deleteStudent/${id}`);
export const searchStudents = (query) => api.get(`/students/search?q=${query}`);
export const getStudentDetails = (serialNumber) => api.get(`/students/studentDetails/${serialNumber}`);

export const getStudentDiscount = (serialNumber, academicYear) =>
  api.get(`/students/serial/${serialNumber}/discount/${academicYear}`);

export const setStudentDiscount = (serialNumber, payload) =>
  api.post(`/students/serial/${serialNumber}/discount`, payload);

export const getStudentsCount = async () => {
  const res = await api.get("/students/getStudentsCount");
  return res.data; 
};

export const getSchoolFees = async (academicYear) => {
  if (academicYear) {
    const r = await api.get('/fees/get', { params: { academicYear } });
    return r.data;
  }
  const r_1 = await api.get('/fees/get');
  return r_1.data;
};

export const setFees = (payload) => api.post('/fees/set', payload);

export const getFees = async (academicYear) => {
  if (academicYear) {
    const r = await api.get('/fees/get', { params: { academicYear } });
    return r.data;
  }
  const r_1 = await api.get('/fees/get');
  return r_1.data;
};


// ---------------- TRANSFERS ----------------

export const getTransfersIn = (page = 1, limit = 10, academicYear = '') => {
    const baseRoute = academicYear ? '/transfers/in/filter' : '/transfers/in';
    let url = `${baseRoute}?page=${page}&limit=${limit}`;

    if (academicYear && baseRoute.includes('filter')) {
        url += `&academicYear=${academicYear}`;
    }
    return api.get(url);
};

export const getTransfersOut = (page = 1, limit = 10, academicYear = '') => {
    const baseRoute = academicYear ? '/transfers/out/filter' : '/transfers/out';
    let url = `${baseRoute}?page=${page}&limit=${limit}`;
    if (academicYear && baseRoute.includes('filter')) {
        url += `&academicYear=${academicYear}`;
    }
    return api.get(url);
};


export const addTransferIn = (payload) => api.post("/transfers/addTransferIn", payload);
export const addTransferOut = (payload) => api.post("/transfers/addTransferOut", payload);
export const getTransfersByStudent = (studentId) =>api.get(`/transfers/getTransfersByStudent/${studentId}`);
// transfer IN
export const updateTransferIn = (studentId, data) =>api.put(`/transfers/updateTransferIn/${studentId}`, data);

// transfer OUT
export const updateTransferOut = (studentId, data) =>api.put(`/transfers/updateTransferOut/${studentId}`, data);
export const updateOutOfSchoolRecord = (serialNumber, data) =>api.put(`/students/out-of-school/${serialNumber}`, data);


// ---------------- OUT OF SCHOOL  ----------------
export const getOutOfSchoolRecords = (page = 1, limit = 10) => api.get(`/students/out-of-school?page=${page}&limit=${limit}`);
export const addOutOfSchoolRecord = (recordData) => api.post('/students/out-of-school', recordData);
export const getOutOfSchoolRecordByStudent = (studentId) => api.get(`/students/out-of-school/${studentId}`);

// ---------------- CLASS GROUPS ----------------
export const getClassGroups = (params) => api.get('/classGroups/getClasses', { params });
export const addClassGroup = (classData) => api.post('/classGroups/add', classData);
export const updateClassGroup = (id, updateData) => api.put(`/classGroups/updateClasses/${id}`, updateData);
export const verifyStudent = (serialNumber) => api.post('/classGroups/verify', { serialNumber });
export const getClassGroupById = (id) => api.get(`/classGroups/${id}`);
export const deleteClassGroup = (id) => api.delete(`/classGroups/${id}`);
export const addStudentsToClassGroup = (id, studentIdsPayload) => api.post(`/classGroups/${id}/students`, studentIdsPayload);
export const getClassCount = async () => {
  const res = await api.get("/classGroups/count");
  return res.data;
};
// Excel export — returns full Student rows for each requested class group id
export const getClassGroupsForExport = (classGroupIds) =>
  api.post('/classGroups/exportData', { classGroupIds });

// ---------------- TRANSACTIONS ----------------
export const getCashForDay = (date) => api.get(`/transaction/cash?date=${date}`);
export const addPaymentBySerial = (serialNumber, paymentData) =>api.post(`/transaction/addPayments/${serialNumber}`, paymentData);
export const addPaymentByFullName = (paymentData) =>api.post('/transaction/addPayments', paymentData);
export const addExpense = (expenseData) => api.post('/transaction/expenses', expenseData);
export const addExternalExpense = (expenseData) => api.post('/transaction/externalExpense', expenseData);
export const getStudentFees = (serialNumber, academicYear) =>api.get(`/transaction/studentfees/${serialNumber}/${academicYear}`);
export const getInstallments = (params) =>api.get('/transaction/installments', { params });
export const getExpenses = (params) => api.get('/transaction/getExpenses', { params });
export const addRepairExpense = (data) => api.post("/transaction/addRepair", data);

export const getStudentsWithIncompleteFees = async () => {
  const res = await api.get("/finance/incomplete-fees");
  return res.data;
};
export const getIncompleteFeesDetails = async () => {
  const res = await api.get("/finance/incomplete-fees/details");
  return res.data;
};

export const getFilteredIncompleteFeesDetails = async (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const url = `/finance/fees/incomplete${qs ? `?${qs}` : ""}`;
  const { data } = await api.get(url);
  return data; 
};
// ---------------- CLOTHES ----------------
export const getClothesStock = () => api.get('/clothes/get');
export const addClothesStock = (payload) => api.post('/clothes/add', payload);
export const addQuantityToClothes = (stockId, payload) =>api.put(`/clothes/edit/${stockId}`, payload);
export const exportClothes = (stockId, payload) =>api.post(`/clothes/export/${stockId}`, payload);
export const deleteClothesStock = (stockId) =>api.delete(`/clothes/delete/${stockId}`);

// ---------------- BOOKS  ----------------
export const getBookStocks = () => api.get('/books');
export const addBookStock = (payload) => api.post('/books', payload);
export const updateBookStock = (stockId, payload) => api.put(`/books/update/${stockId}`, payload);
export const exportBooks = (stockId, payload) => api.post(`/books/export/${stockId}`, payload);
export const deleteBookStock = (stockId) => api.delete(`/books/${stockId}`);


// ---------------- staticFees  ----------------

// 🔹 جلب السجلات (يدعم group, academicYear, className, q, page, limit)
export const listStaticFees = async (params = {}) => {
  const res = await api.get("/staticFees", { params });
  return res.data;
};

// 🔹 إضافة سجل طالب يدوي
export const createStaticFee = async (payload) => {
  const res = await api.post("/staticFees", payload);
  return res.data;
};

// 🔹 تعديل سجل
export const updateStaticFee = async (id, payload) => {
  const res = await api.put(`/staticFees/${id}`, payload);
  return res.data;
};

// 🔹 حذف (Soft Delete)
export const deleteStaticFee = async (id) => {
  const res = await api.delete(`/staticFees/${id}`);
  return res.data;
};

// 🔹 حذف نهائي (إن أردت)
export const hardDeleteStaticFee = async (id) => {
  const res = await api.delete(`/staticFees/${id}/permanent`);
  return res.data;
};
export const createStaticFeeGroup = async (payload) => {
  const res = await api.post("/staticFees/group", payload);
  return res.data;
};
export const getStaticFeeSummary = async (params) => {
  const res = await api.get("/staticFees/summary", { params });
  return res.data;
};
export const getStaticSummary = async () => {
  const res = await api.get("/staticFees/staticSummary");
  return res.data;
};
// services/api (assuming you have an axios instance `api`)
export const getTeachers = (params) => api.get("/teacher", { params });
// expects response: { items: [...], total: N, page: 1, totalPages: M } OR a plain array
export const getTransports = (params) => api.get("/transport", { params });


export const addTeacherSalary = (payload) => api.post("/transaction/teacher/salary", payload);

export const addDriverSalary  = (payload) => api.post("/transaction/driver-salary", payload);

// Owner-only: edit / delete an installment or expense row.
export const updateTransaction = (id, payload) => api.put(`/transaction/${id}`, payload);
export const deleteTransaction = (id) => api.delete(`/transaction/${id}`);

// ---------------- USER ACCOUNTS (owner-only) ----------------
export const listUsers = () => api.get('/users');
export const changeUserPassword = (id, password) =>
  api.put(`/users/${id}/password`, { password });
export const deleteUser = (id) => api.delete(`/users/${id}`);

export default api;
